import {
  addToCart
} from "./chunk--chunk-FJ3DOTW4.vbt.js";

// src/js/components/ProductForm.js
var ProductForm = class {
  constructor(el, sel) {
    this.el = el;
    this.max = el.getAttribute("data-max");
    this.isPdpForm = el.getAttribute("data-product-form-pdp") !== null;
    this.input = el.querySelector('input[name="id"]');
    this.subscriptionModal = document.querySelector("#subscribe-save-modal");
    this.subscriptionModalToggle = document.querySelector(
      "#subscribe-save-modal-toggle"
    );
    if (this.subscriptionModal) {
      this.subscriptionModalButton = this.subscriptionModal.querySelector(
        "[data-current-value]"
      );
      this.subscriptionModalInput = this.subscriptionModal.querySelector(
        'input[name="selling_plan"]'
      );
    }
    const quantitySelector = this.el.querySelector("[data-quantity]");
    if (quantitySelector) {
      this.quantity = quantitySelector.querySelector("input");
      this.plus = quantitySelector.querySelector("[data-plus]");
      this.minus = quantitySelector.querySelector("[data-minus]");
    }
  }
  init() {
    this.initSubmitListener();
    if (this.quantity) {
      this.initQuantitySelector();
    }
    if (document.querySelector("#purchaseType--onetime")?.checked) {
      document.querySelectorAll('input[name="selling_plan"]').forEach((el) => {
        el.value = "";
      });
    }
    if (window.location.href.includes("?variant=") && this.isPdpForm) {
      this.input.value = window.location.href.split("?variant=")[1].split("&")[0];
    }
    if (this.el.querySelector("[data-one-time-submit]")) {
      this.el.querySelectorAll("[data-one-time-submit]").forEach((el) => {
        el.addEventListener("click", async () => {
          this.el.querySelector('input[name="selling_plan"]').setAttribute("value", "");
          this.atcHandler();
          this.resetSubscriptionModal();
        });
      });
    }
  }
  resetSubscriptionModal() {
    if (this.subscriptionModalToggle)
      this.subscriptionModalToggle.checked = false;
    if (this.subscriptionModalInput && this.subscriptionModalButton) {
      this.subscriptionModalInput.value = this.subscriptionModalButton.getAttribute("data-current-value");
    }
  }
  async atcHandler() {
    const formData = new FormData(this.el);
    const body = new URLSearchParams(formData);
    const returnStatus = await addToCart(body);
    return returnStatus;
  }
  initSubmitListener() {
    this.el.addEventListener("submit", async (e) => {
      e.preventDefault();
      this.atcHandler();
      if (this.el.hasAttribute("data-upsell-form")) {
        this.resetSubscriptionModal();
      }
    });
  }
  initQuantitySelector() {
    this.plus.addEventListener("click", () => {
      let max = this.plus.getAttribute("data-max");
      if (max) {
        max = parseInt(max);
        if (this.quantity.value >= max) {
          return;
        }
      }
      this.quantity.value++;
    });
    this.minus.addEventListener("click", () => {
      if (this.quantity.value <= 1) {
        return;
      }
      this.quantity.value--;
    });
  }
};
var ProductForm_default = ProductForm;

export {
  ProductForm_default
};
